import { getJsonRpcAddress } from './chunk-Z5ML27IN.mjs';
import { __export } from './chunk-FHBV65QG.mjs';
import { backOff } from 'exponential-backoff';
import { webSocket, http, createPublicClient, createWalletClient, custom, decodeEventLog, isAddressEqual, encodeAbiParameters, decodeAbiParameters } from 'viem';

// src/contract/abi/index.ts
var abi_exports = {};
__export(abi_exports, {
  cbt: () => cbt,
  entry: () => entry,
  linklist: () => linklist,
  mira: () => mira,
  newbieVilla: () => newbieVilla,
  periphery: () => periphery,
  tips: () => tips,
  tipsWithConfig: () => tipsWithConfig,
  tipsWithFee: () => tipsWithFee
});

// src/contract/abi/entry.ts
var entry = [
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "ErrCharacterNotExists",
    type: "error"
  },
  { inputs: [], name: "ErrHandleContainsInvalidCharacters", type: "error" },
  { inputs: [], name: "ErrHandleExists", type: "error" },
  { inputs: [], name: "ErrHandleLengthInvalid", type: "error" },
  { inputs: [], name: "ErrNotCharacterOwner", type: "error" },
  { inputs: [], name: "ErrNotEnoughPermission", type: "error" },
  { inputs: [], name: "ErrNotEnoughPermissionForThisNote", type: "error" },
  { inputs: [], name: "ErrNoteIsDeleted", type: "error" },
  { inputs: [], name: "ErrNoteLocked", type: "error" },
  { inputs: [], name: "ErrNoteNotExists", type: "error" },
  { inputs: [], name: "ErrSignatureExpired", type: "error" },
  { inputs: [], name: "ErrSignatureInvalid", type: "error" },
  { inputs: [], name: "ErrSocialTokenExists", type: "error" },
  { inputs: [], name: "ErrTokenNotExists", type: "error" },
  {
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "approved", type: "address" },
      { indexed: true, name: "tokenId", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "operator", type: "address" },
      { indexed: false, name: "approved", type: "bool" }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: true, name: "tokenId", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      { name: "to", type: "address" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "linklistId", type: "uint256" }],
    name: "burnLinklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "to", type: "address" },
          { name: "handle", type: "string" },
          { name: "uri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "createCharacter",
    outputs: [{ name: "characterId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "to", type: "address" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "createThenLinkCharacter",
    outputs: [{ name: "characterId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" }
    ],
    name: "deleteNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "getCharacter",
    outputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "handle", type: "string" },
          { name: "uri", type: "string" },
          { name: "noteCount", type: "uint256" },
          { name: "socialToken", type: "address" },
          { name: "linkModule", type: "address" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "handle", type: "string" }],
    name: "getCharacterByHandle",
    outputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "handle", type: "string" },
          { name: "uri", type: "string" },
          { name: "noteCount", type: "uint256" },
          { name: "socialToken", type: "address" },
          { name: "linkModule", type: "address" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "getCharacterUri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getDomainSeparator",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "getHandle",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLinklistContract",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinklistId",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkListId", type: "uint256" }],
    name: "getLinklistType",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinklistUri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" }
    ],
    name: "getNote",
    outputs: [
      {
        components: [
          { name: "linkItemType", type: "bytes32" },
          { name: "linkKey", type: "bytes32" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "mintModule", type: "address" },
          { name: "mintNFT", type: "address" },
          { name: "deleted", type: "bool" },
          { name: "locked", type: "bool" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "operator", type: "address" }
    ],
    name: "getOperatorPermissions",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "getOperators",
    outputs: [{ name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" }
    ],
    name: "getOperators4Note",
    outputs: [
      { name: "blocklist", type: "address[]" },
      { name: "allowlist", type: "address[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "account", type: "address" }],
    name: "getPrimaryCharacterId",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRevision",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "operator", type: "address" },
      { name: "permissionBitMap", type: "uint256" }
    ],
    name: "grantOperatorPermissions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "operator", type: "address" },
      { name: "permissionBitMap", type: "uint256" },
      {
        components: [
          { name: "v", type: "uint8" },
          { name: "r", type: "bytes32" },
          { name: "s", type: "bytes32" },
          { name: "deadline", type: "uint256" }
        ],
        name: "sig",
        type: "tuple"
      }
    ],
    name: "grantOperatorPermissionsWithSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" },
      { name: "blocklist", type: "address[]" },
      { name: "allowlist", type: "address[]" }
    ],
    name: "grantOperators4Note",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "name_", type: "string" },
      { name: "symbol_", type: "string" },
      { name: "linklist_", type: "address" },
      { name: "mintNFTImpl_", type: "address" },
      { name: "periphery_", type: "address" },
      { name: "newbieVilla_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "owner", type: "address" },
      { name: "operator", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" },
      { name: "operator", type: "address" }
    ],
    name: "isOperatorAllowedForNote",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "isPrimaryCharacter",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "ethAddress", type: "address" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toUri", type: "string" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkAnyUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterId", type: "uint256" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkCharacter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "tokenAddress", type: "address" },
          { name: "tokenId", type: "uint256" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toLinkListId", type: "uint256" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkLinklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterId", type: "uint256" },
          { name: "toNoteId", type: "uint256" },
          { name: "linkType", type: "bytes32" },
          { name: "data", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" }
    ],
    name: "lockNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" },
          { name: "to", type: "address" },
          { name: "mintModuleData", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "mintNote",
    outputs: [{ name: "tokenId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ name: "results", type: "bytes[]" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "postNote",
    outputs: [{ name: "noteId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      { name: "ethAddress", type: "address" }
    ],
    name: "postNote4Address",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      { name: "uri", type: "string" }
    ],
    name: "postNote4AnyUri",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      { name: "toCharacterId", type: "uint256" }
    ],
    name: "postNote4Character",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      {
        components: [
          { name: "tokenAddress", type: "address" },
          { name: "erc721TokenId", type: "uint256" }
        ],
        name: "erc721",
        type: "tuple"
      }
    ],
    name: "postNote4ERC721",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      { name: "toLinklistId", type: "uint256" }
    ],
    name: "postNote4Linklist",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" },
          { name: "locked", type: "bool" }
        ],
        name: "vars",
        type: "tuple"
      },
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" }
        ],
        name: "note",
        type: "tuple"
      }
    ],
    name: "postNote4Note",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "resolver",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "tokenId", type: "uint256" },
      { name: "_data", type: "bytes" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "operator", type: "address" },
      { name: "approved", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "newUri", type: "string" }
    ],
    name: "setCharacterUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "newHandle", type: "string" }
    ],
    name: "setHandle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "setLinkModule4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" },
          { name: "linkModule", type: "address" },
          { name: "linkModuleInitData", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "setLinkModule4Note",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "linklistId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "setLinklistType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "linklistId", type: "uint256" },
      { name: "uri", type: "string" }
    ],
    name: "setLinklistUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" },
          { name: "mintModule", type: "address" },
          { name: "mintModuleInitData", type: "bytes" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "setMintModule4Note",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" },
      { name: "newUri", type: "string" }
    ],
    name: "setNoteUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "setPrimaryCharacterId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "tokenAddress", type: "address" }
    ],
    name: "setSocialToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "index", type: "uint256" }],
    name: "tokenByIndex",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "owner", type: "address" },
      { name: "index", type: "uint256" }
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "ethAddress", type: "address" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toUri", type: "string" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkAnyUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterId", type: "uint256" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkCharacter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "tokenAddress", type: "address" },
          { name: "tokenId", type: "uint256" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toLinkListId", type: "uint256" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkLinklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterId", type: "uint256" },
          { name: "toNoteId", type: "uint256" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "unlinkNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { indexed: true, name: "linklistId", type: "uint256" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "linkType", type: "bytes32" }
    ],
    name: "AttachLinklist",
    type: "event"
  },
  {
    inputs: [
      { indexed: false, name: "name", type: "string" },
      { indexed: false, name: "symbol", type: "string" },
      { indexed: false, name: "timestamp", type: "uint256" }
    ],
    name: "BaseInitialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "creator", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "handle", type: "string" },
      { indexed: false, name: "timestamp", type: "uint256" }
    ],
    name: "CharacterCreated",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: false, name: "noteId", type: "uint256" }
    ],
    name: "DeleteNote",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "linklistId", type: "uint256" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "linkType", type: "bytes32" }
    ],
    name: "DetachLinklist",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "operator", type: "address" },
      { indexed: false, name: "permissionBitMap", type: "uint256" }
    ],
    name: "GrantOperatorPermissions",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: false, name: "blocklist", type: "address[]" },
      { indexed: false, name: "allowlist", type: "address[]" }
    ],
    name: "GrantOperators4Note",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "ethAddress", type: "address" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "LinkAddress",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: false, name: "toUri", type: "string" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "LinkAnyUri",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "LinkCharacter",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "linkType", type: "bytes32" },
      { indexed: false, name: "clFromCharacterId", type: "uint256" },
      { indexed: false, name: "clToCharacterId", type: "uint256" },
      { indexed: false, name: "clLinkType", type: "bytes32" }
    ],
    name: "LinkCharacterLink",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "tokenAddress", type: "address" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "LinkERC721",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toLinklistId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: true, name: "linklistId", type: "uint256" }
    ],
    name: "LinkLinklist",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "LinkNote",
    type: "event"
  },
  {
    inputs: [{ indexed: false, name: "timestamp", type: "uint256" }],
    name: "LinklistNFTInitialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: false, name: "noteId", type: "uint256" }
    ],
    name: "LockNote",
    type: "event"
  },
  {
    inputs: [
      { indexed: false, name: "characterId", type: "uint256" },
      { indexed: false, name: "noteId", type: "uint256" },
      { indexed: false, name: "timestamp", type: "uint256" }
    ],
    name: "MintNFTInitialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "to", type: "address" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: false, name: "tokenAddress", type: "address" },
      { indexed: false, name: "tokenId", type: "uint256" }
    ],
    name: "MintNote",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: true, name: "linkKey", type: "bytes32" },
      { indexed: false, name: "linkItemType", type: "bytes32" },
      { indexed: false, name: "data", type: "bytes" }
    ],
    name: "PostNote",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: true, name: "amount", type: "uint256" },
      { indexed: false, name: "approvedAddresses", type: "address[]" }
    ],
    name: "SetApprovedMintAmount4Addresses",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: false, name: "newUri", type: "string" }
    ],
    name: "SetCharacterUri",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: false, name: "newHandle", type: "string" }
    ],
    name: "SetHandle",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "linkModule", type: "address" },
      { indexed: false, name: "linkModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetLinkModule4Address",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "linkModule", type: "address" },
      { indexed: false, name: "linkModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetLinkModule4Character",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "tokenAddress", type: "address" },
      { indexed: true, name: "tokenId", type: "uint256" },
      { indexed: true, name: "linkModule", type: "address" },
      { indexed: false, name: "linkModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetLinkModule4ERC721",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "linklistId", type: "uint256" },
      { indexed: true, name: "linkModule", type: "address" },
      { indexed: false, name: "linkModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetLinkModule4Linklist",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: true, name: "linkModule", type: "address" },
      { indexed: false, name: "linkModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetLinkModule4Note",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "noteId", type: "uint256" },
      { indexed: true, name: "mintModule", type: "address" },
      { indexed: false, name: "mintModuleInitData", type: "bytes" },
      { indexed: false, name: "returnData", type: "bytes" }
    ],
    name: "SetMintModule4Note",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: false, name: "noteId", type: "uint256" },
      { indexed: false, name: "newUri", type: "string" }
    ],
    name: "SetNoteUri",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "oldCharacterId", type: "uint256" }
    ],
    name: "SetPrimaryCharacterId",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "tokenAddress", type: "address" }
    ],
    name: "SetSocialToken",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "ethAddress", type: "address" },
      { indexed: false, name: "linkType", type: "bytes32" }
    ],
    name: "UnlinkAddress",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: false, name: "toUri", type: "string" },
      { indexed: false, name: "linkType", type: "bytes32" }
    ],
    name: "UnlinkAnyUri",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" }
    ],
    name: "UnlinkCharacter",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "linkType", type: "bytes32" },
      { indexed: false, name: "clFromCharactereId", type: "uint256" },
      { indexed: false, name: "clToCharacterId", type: "uint256" },
      { indexed: false, name: "clLinkType", type: "bytes32" }
    ],
    name: "UnlinkCharacterLink",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "tokenAddress", type: "address" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "UnlinkERC721",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toLinklistId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: true, name: "linklistId", type: "uint256" }
    ],
    name: "UnlinkLinklist",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "linkType", type: "bytes32" },
      { indexed: false, name: "linklistId", type: "uint256" }
    ],
    name: "UnlinkNote",
    type: "event"
  },
  {
    inputs: [{ indexed: false, name: "timestamp", type: "uint256" }],
    name: "Web3EntryInitialized",
    type: "event"
  }
];

// src/contract/abi/periphery.ts
var periphery = [
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingAddress",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingAddresses",
    outputs: [{ name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingAnyUri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingAnyUris",
    outputs: [{ name: "results", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingCharacterId",
    outputs: [{ name: "characterId", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingCharacterIds",
    outputs: [{ name: "results", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingERC721",
    outputs: [
      {
        components: [
          { name: "tokenAddress", type: "address" },
          { name: "erc721TokenId", type: "uint256" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingERC721s",
    outputs: [
      {
        components: [
          { name: "tokenAddress", type: "address" },
          { name: "erc721TokenId", type: "uint256" }
        ],
        name: "results",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingLinklistId",
    outputs: [{ name: "linklistId", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingLinklistIds",
    outputs: [{ name: "linklistIds", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingNote",
    outputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "getLinkingNotes",
    outputs: [
      {
        components: [
          { name: "linkItemType", type: "bytes32" },
          { name: "linkKey", type: "bytes32" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "mintModule", type: "address" },
          { name: "mintNFT", type: "address" },
          { name: "deleted", type: "bool" },
          { name: "locked", type: "bool" }
        ],
        name: "results",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "offset", type: "uint256" },
      { name: "limit", type: "uint256" }
    ],
    name: "getNotesByCharacterId",
    outputs: [
      {
        components: [
          { name: "linkItemType", type: "bytes32" },
          { name: "linkKey", type: "bytes32" },
          { name: "contentUri", type: "string" },
          { name: "linkModule", type: "address" },
          { name: "mintModule", type: "address" },
          { name: "mintNFT", type: "address" },
          { name: "deleted", type: "bool" },
          { name: "locked", type: "bool" }
        ],
        name: "results",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "_web3Entry", type: "address" },
      { name: "_linklist", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterIds", type: "uint256[]" },
          { name: "data", type: "bytes[]" },
          { name: "toAddresses", type: "address[]" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "linkCharactersInBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "linklist",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { name: "account", type: "address" },
          { name: "handle", type: "string" },
          { name: "uri", type: "string" },
          { name: "toAddresses", type: "address[]" },
          { name: "linkType", type: "bytes32" }
        ],
        name: "vars",
        type: "tuple"
      }
    ],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "web3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/contract/abi/cbt.ts
var cbt = [
  {
    inputs: [{ name: "web3Entry", type: "address" }],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "operator", type: "address" },
      { indexed: false, name: "approved", type: "bool" }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "uint256" },
      { indexed: true, name: "tokenId", type: "uint256" },
      { indexed: true, name: "amount", type: "uint256" }
    ],
    name: "Burn",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "to", type: "uint256" },
      { indexed: true, name: "tokenId", type: "uint256" },
      { indexed: true, name: "tokenNumber", type: "uint256" }
    ],
    name: "Mint",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "previousAdminRole", type: "bytes32" },
      { indexed: true, name: "newAdminRole", type: "bytes32" }
    ],
    name: "RoleAdminChanged",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleGranted",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleRevoked",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "ids", type: "uint256[]" },
      { indexed: false, name: "values", type: "uint256[]" }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "id", type: "uint256" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    inputs: [
      { indexed: false, name: "value", type: "string" },
      { indexed: true, name: "id", type: "uint256" }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_web3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "account", type: "address" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "accounts", type: "address[]" },
      { name: "tokenIds", type: "uint256[]" }
    ],
    name: "balanceOfBatch",
    outputs: [{ name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "tokenId", type: "uint256" },
      { name: "amount", type: "uint256" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleAdmin",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "index", type: "uint256" }
    ],
    name: "getRoleMember",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleMemberCount",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "hasRole",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "account", type: "address" },
      { name: "operator", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "tokenId", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" },
      { name: "", type: "uint256[]" },
      { name: "", type: "uint256[]" },
      { name: "", type: "bytes" }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" },
      { name: "", type: "uint256" },
      { name: "", type: "uint256" },
      { name: "", type: "bytes" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "operator", type: "address" },
      { name: "approved", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "tokenURI", type: "string" }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "uri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/contract/abi/newbie-villa.ts
var newbieVilla = [
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "previousAdminRole", type: "bytes32" },
      { indexed: true, name: "newAdminRole", type: "bytes32" }
    ],
    name: "RoleAdminChanged",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleGranted",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleRevoked",
    type: "event"
  },
  {
    inputs: [
      { indexed: false, name: "to", type: "address" },
      { indexed: false, name: "characterId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ERC1820_REGISTRY",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TOKENS_RECIPIENT_INTERFACE_HASH",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleAdmin",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "index", type: "uint256" }
    ],
    name: "getRoleMember",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleMemberCount",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getToken",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "hasRole",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "web3Entry_", type: "address" },
      { name: "xsyncOperator_", type: "address" },
      { name: "token_", type: "address" },
      { name: "admin_", type: "address" },
      { name: "tips_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "operator", type: "address" },
      { name: "", type: "address" },
      { name: "tokenId", type: "uint256" },
      { name: "data", type: "bytes" }
    ],
    name: "onERC721Received",
    outputs: [{ name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" },
      { name: "amount", type: "uint256" }
    ],
    name: "tipCharacter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" },
      { name: "toNoteId", type: "uint256" },
      { name: "amount", type: "uint256" }
    ],
    name: "tipCharacterForNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" },
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "userData", type: "bytes" },
      { name: "operatorData", type: "bytes" }
    ],
    name: "tokensReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "web3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "to", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "nonce", type: "uint256" },
      { name: "expires", type: "uint256" },
      { name: "proof", type: "bytes" }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "xsyncOperator",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/contract/abi/tips.ts
var tips = [
  { inputs: [], name: "ErrCallerNotCharacterOwner", type: "error" },
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" }
    ],
    name: "TipCharacter",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" }
    ],
    name: "TipCharacterForNote",
    type: "event"
  },
  {
    inputs: [],
    name: "ERC1820_REGISTRY",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TOKENS_RECIPIENT_INTERFACE_HASH",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getToken",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getWeb3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "web3Entry_", type: "address" },
      { name: "token_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "", type: "address" },
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "userData", type: "bytes" },
      { name: "operatorData", type: "bytes" }
    ],
    name: "tokensReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/contract/abi/tips-with-fee.ts
var tipsWithFee = [
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "fee", type: "uint256" },
      { indexed: false, name: "feeReceiver", type: "address" }
    ],
    name: "TipCharacter",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: true, name: "toNoteId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "fee", type: "uint256" },
      { indexed: false, name: "feeReceiver", type: "address" }
    ],
    name: "TipCharacterForNote",
    type: "event"
  },
  {
    inputs: [],
    name: "ERC1820_REGISTRY",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TOKENS_RECIPIENT_INTERFACE_HASH",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" },
      { name: "tipAmount", type: "uint256" }
    ],
    name: "getFeeAmount",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" }
    ],
    name: "getFeeFraction",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getToken",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getWeb3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "web3Entry_", type: "address" },
      { name: "token_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "fraction", type: "uint256" }
    ],
    name: "setDefaultFeeFraction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "fraction", type: "uint256" }
    ],
    name: "setFeeFraction4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "noteId", type: "uint256" },
      { name: "fraction", type: "uint256" }
    ],
    name: "setFeeFraction4Note",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "", type: "address" },
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "userData", type: "bytes" },
      { name: "operatorData", type: "bytes" }
    ],
    name: "tokensReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/contract/abi/tips-with-config.ts
var tipsWithConfig = [
  {
    inputs: [{ indexed: true, name: "tipConfigId", type: "uint256" }],
    name: "CancelTips4Character",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "tipConfigId", type: "uint256" },
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "fee", type: "uint256" },
      { indexed: false, name: "feeReceiver", type: "address" },
      { indexed: false, name: "currentRound", type: "uint256" }
    ],
    name: "CollectTips4Character",
    type: "event"
  },
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "tipConfigId", type: "uint256" },
      { indexed: true, name: "fromCharacterId", type: "uint256" },
      { indexed: true, name: "toCharacterId", type: "uint256" },
      { indexed: false, name: "token", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "startTime", type: "uint256" },
      { indexed: false, name: "endTime", type: "uint256" },
      { indexed: false, name: "interval", type: "uint256" },
      { indexed: false, name: "feeReceiver", type: "address" },
      { indexed: false, name: "totalRound", type: "uint256" }
    ],
    name: "SetTipsConfig4Character",
    type: "event"
  },
  {
    inputs: [{ name: "tipConfigId", type: "uint256" }],
    name: "cancelTips4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "tipConfigId", type: "uint256" }],
    name: "collectTips4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "tipAmount", type: "uint256" }
    ],
    name: "getFeeAmount",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" }
    ],
    name: "getFeeFraction",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tipConfigId", type: "uint256" }],
    name: "getTipsConfig",
    outputs: [
      {
        components: [
          { name: "id", type: "uint256" },
          { name: "fromCharacterId", type: "uint256" },
          { name: "toCharacterId", type: "uint256" },
          { name: "token", type: "address" },
          { name: "amount", type: "uint256" },
          { name: "startTime", type: "uint256" },
          { name: "endTime", type: "uint256" },
          { name: "interval", type: "uint256" },
          { name: "feeReceiver", type: "address" },
          { name: "totalRound", type: "uint256" },
          { name: "currentRound", type: "uint256" }
        ],
        name: "config",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" }
    ],
    name: "getTipsConfigId",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getWeb3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "web3Entry_", type: "address" }],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "fraction", type: "uint256" }
    ],
    name: "setDefaultFeeFraction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "feeReceiver", type: "address" },
      { name: "characterId", type: "uint256" },
      { name: "fraction", type: "uint256" }
    ],
    name: "setFeeFraction4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "fromCharacterId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" },
      { name: "token", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "startTime", type: "uint256" },
      { name: "endTime", type: "uint256" },
      { name: "interval", type: "uint256" },
      { name: "feeReceiver", type: "address" }
    ],
    name: "setTipsConfig4Character",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/contract/abi/mira.ts
var mira = [
  {
    inputs: [
      { name: "name_", type: "string" },
      { name: "symbol_", type: "string" },
      { name: "admin", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "tokenHolder", type: "address" }
    ],
    name: "AuthorizedOperator",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "from", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "data", type: "bytes" },
      { indexed: false, name: "operatorData", type: "bytes" }
    ],
    name: "Burned",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "data", type: "bytes" },
      { indexed: false, name: "operatorData", type: "bytes" }
    ],
    name: "Minted",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "tokenHolder", type: "address" }
    ],
    name: "RevokedOperator",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "previousAdminRole", type: "bytes32" },
      { indexed: true, name: "newAdminRole", type: "bytes32" }
    ],
    name: "RoleAdminChanged",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleGranted",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "role", type: "bytes32" },
      { indexed: true, name: "account", type: "address" },
      { indexed: true, name: "sender", type: "address" }
    ],
    name: "RoleRevoked",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "operator", type: "address" },
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "amount", type: "uint256" },
      { indexed: false, name: "data", type: "bytes" },
      { indexed: false, name: "operatorData", type: "bytes" }
    ],
    name: "Sent",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "BLOCK_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "holder", type: "address" },
      { name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "spender", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "operator", type: "address" }],
    name: "authorizeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "tokenHolder", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "amount", type: "uint256" },
      { name: "data", type: "bytes" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultOperators",
    outputs: [{ name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleAdmin",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "index", type: "uint256" }
    ],
    name: "getRoleMember",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "role", type: "bytes32" }],
    name: "getRoleMemberCount",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "granularity",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "hasRole",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "operator", type: "address" },
      { name: "tokenHolder", type: "address" }
    ],
    name: "isOperatorFor",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "account", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "data", type: "bytes" },
      { name: "operatorData", type: "bytes" }
    ],
    name: "operatorBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "data", type: "bytes" },
      { name: "operatorData", type: "bytes" }
    ],
    name: "operatorSend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "operator", type: "address" }],
    name: "revokeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "data", type: "bytes" }
    ],
    name: "send",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "holder", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/contract/abi/linklist.ts
var linklist = [
  { inputs: [], name: "ErrCallerNotWeb3Entry", type: "error" },
  { inputs: [], name: "ErrCallerNotWeb3EntryOrNotOwner", type: "error" },
  { inputs: [], name: "ErrTokenNotExists", type: "error" },
  {
    inputs: [
      { indexed: true, name: "from", type: "uint256" },
      { indexed: true, name: "tokenId", type: "uint256" }
    ],
    name: "Burn",
    type: "event"
  },
  {
    inputs: [{ indexed: false, name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "tokenId", type: "uint256" },
      { indexed: true, name: "newlinkType", type: "bytes32" }
    ],
    name: "LinkTypeSet",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "characterId", type: "uint256" },
      { indexed: true, name: "tokenId", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "tokenId", type: "uint256" },
      { indexed: false, name: "uri", type: "string" }
    ],
    name: "UriSet",
    type: "event"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "Uri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "Web3Entry",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "ethAddress", type: "address" }
    ],
    name: "addLinkingAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toUri", type: "string" }
    ],
    name: "addLinkingAnyUri",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" }
    ],
    name: "addLinkingCharacterId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "tokenAddress", type: "address" },
      { name: "erc721TokenId", type: "uint256" }
    ],
    name: "addLinkingERC721",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "linklistId", type: "uint256" }
    ],
    name: "addLinkingLinklistId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" },
      { name: "toNoteId", type: "uint256" }
    ],
    name: "addLinkingNote",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "characterId", type: "uint256" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "characterOwnerOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getCurrentTakeOver",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkType",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingAddressListLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingAddresses",
    outputs: [{ name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingAnyListLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingAnyUri",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingAnyUriKeys",
    outputs: [{ name: "", type: "bytes32[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingAnyUris",
    outputs: [{ name: "results", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingCharacterIds",
    outputs: [{ name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingCharacterListLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingERC721",
    outputs: [
      {
        components: [
          { name: "tokenAddress", type: "address" },
          { name: "erc721TokenId", type: "uint256" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingERC721ListLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingERC721s",
    outputs: [
      {
        components: [
          { name: "tokenAddress", type: "address" },
          { name: "erc721TokenId", type: "uint256" }
        ],
        name: "results",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingLinklistIds",
    outputs: [{ name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingLinklistLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "linkKey", type: "bytes32" }],
    name: "getLinkingNote",
    outputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingNoteListLength",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getLinkingNotes",
    outputs: [
      {
        components: [
          { name: "characterId", type: "uint256" },
          { name: "noteId", type: "uint256" }
        ],
        name: "results",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "getOwnerCharacterId",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "name_", type: "string" },
      { name: "symbol_", type: "string" },
      { name: "web3Entry_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "characterId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "mint",
    outputs: [{ name: "tokenId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "ethAddress", type: "address" }
    ],
    name: "removeLinkingAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toUri", type: "string" }
    ],
    name: "removeLinkingAnyUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" }
    ],
    name: "removeLinkingCharacterId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "tokenAddress", type: "address" },
      { name: "erc721TokenId", type: "uint256" }
    ],
    name: "removeLinkingERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "linklistId", type: "uint256" }
    ],
    name: "removeLinkingLinklistId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "toCharacterId", type: "uint256" },
      { name: "toNoteId", type: "uint256" }
    ],
    name: "removeLinkingNote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "linkType", type: "bytes32" }
    ],
    name: "setLinkType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "uri", type: "string" }
    ],
    name: "setUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/utils/logger.ts
var PREFIX = "[crossbell]";
var isProduction = globalThis?.process?.env?.NODE_ENV === "production";
function log(...message) {
  if (!isProduction)
    console.log(PREFIX, ...message);
}
function warn(...message) {
  console.warn(PREFIX, ...message);
}

// src/utils/viem.ts
function createTransport(url) {
  const url_ = getJsonRpcAddress() ?? url;
  if (url_.startsWith("ws")) {
    return webSocket(url_, {
      timeout: 3e4,
      key: "crossbell",
      name: "crossbell",
      retryCount: 5,
      retryDelay: 5e3
    });
  }
  return http(url_, {
    timeout: 3e4,
    key: "crossbell",
    name: "crossbell"
  });
}
function createPublicClientFromChain(chain, rpcUrl) {
  const transport = createTransport(rpcUrl ?? chain.rpcUrls.default.http[0]);
  return createPublicClient({
    transport,
    chain,
    pollingInterval: 100,
    batch: {
      multicall: true
    }
  });
}
function createWalletClientFromPrivateKeyAccount(account, chain, rpcUrl) {
  const transport = createTransport(rpcUrl ?? chain.rpcUrls.default.http[0]);
  return createWalletClient({
    transport,
    chain,
    account,
    pollingInterval: 100
  });
}
function getProviderAccount(provider) {
  if ("selectedAddress" in provider && provider.selectedAddress) {
    return addressToAccount(provider.selectedAddress);
  }
  if ("send" in provider && typeof provider.send === "function") {
    const result = provider.send({ method: "eth_accounts" });
    if (result?.result?.[0]) {
      return addressToAccount(result.result[0]);
    }
  }
}
function createWalletClientFromProvider(provider, account, chain) {
  return createWalletClient({
    transport: custom(provider),
    chain,
    account,
    pollingInterval: 100
  });
}
function parseLog(logs, targetTopic, {
  throwOnMultipleLogsFound,
  returnMultipleLogs
} = {}) {
  const parsedLogs = logs.map((log2) => {
    try {
      return decodeEventLog({
        abi: [...entry, ...linklist],
        ...log2
      });
    } catch {
      return void 0;
    }
  }).filter((log2) => log2?.eventName === targetTopic);
  if (parsedLogs.length === 0) {
    throw new Error(`Log with topic ${targetTopic} not found`);
  }
  if (throwOnMultipleLogsFound && parsedLogs.length > 1) {
    throw new Error(`More than one log with topic ${parsedLogs} found`);
  }
  if (returnMultipleLogs)
    return parsedLogs;
  return parsedLogs[0];
}
function addressToAccount(address) {
  if (typeof address === "string")
    return {
      type: "json-rpc",
      address
    };
  return address;
}
async function waitForTransactionReceiptWithRetry(client, hash) {
  return backOff(() => client.waitForTransactionReceipt({ hash }), {
    retry: (e, i) => {
      log("retrying waitForTransactionReceipt", { hash, i, e });
      return true;
    },
    numOfAttempts: 6,
    timeMultiple: 2,
    startingDelay: 100
  });
}

// src/utils/sdn.ts
var sdnList = /* @__PURE__ */ new Set([
  "0x8589427373d6d84e98730d7795d8f6f8731fda16",
  "0x722122df12d4e14e13ac3b6895a86e84145b6967",
  "0xdd4c48c0b24039969fc16d1cdf626eab821d3384",
  "0xd90e2f925da726b50c4ed8d0fb90ad053324f31b",
  "0xd96f2b1c14db8458374d9aca76e26c3d18364307",
  "0x4736dcf1b7a3d580672cce6e7c65cd5cc9cfba9d",
  "0xd4b88df4d29f5cedd6857912842cff3b20c8cfa3",
  "0x910cbd523d972eb0a6f4cae4618ad62622b39dbf",
  "0xa160cdab225685da1d56aa342ad8841c3b53f291",
  "0xfd8610d20aa15b7b2e3be39b396a1bc3516c7144",
  "0xf60dd140cff0706bae9cd734ac3ae76ad9ebc32a",
  "0x22aaa7720ddd5388a3c0a3333430953c68f1849b",
  "0xba214c1c1928a32bffe790263e38b4af9bfcd659",
  "0xb1c8094b234dce6e03f10a5b673c1d8c69739a00",
  "0x527653ea119f3e6a1f5bd18fbf4714081d7b31ce",
  "0x58e8dcc13be9780fc42e8723d8ead4cf46943df2",
  "0xd691f27f38b395864ea86cfc7253969b409c362d",
  "0xaeaac358560e11f52454d997aaff2c5731b6f8a6",
  "0x1356c899d8c9467c7f71c195612f8a395abf2f0a",
  "0xa60c772958a3ed56c1f15dd055ba37ac8e523a0d",
  "0x169ad27a470d064dede56a2d3ff727986b15d52b",
  "0x0836222f2b2b24a3f36f98668ed8f0b38d1a872f",
  "0xf67721a2d8f736e75a49fdd7fad2e31d8676542a",
  "0x9ad122c22b14202b4490edaf288fdb3c7cb3ff5e",
  "0x905b63fff465b9ffbf41dea908ceb12478ec7601",
  "0x07687e702b410fa43f4cb4af7fa097918ffd2730",
  "0x94a1b5cdb22c43faab4abeb5c74999895464ddaf",
  "0xb541fc07bc7619fd4062a54d96268525cbc6ffef",
  "0x12d66f87a04a9e220743712ce6d9bb1b5616b8fc",
  "0x47ce0c6ed5b0ce3d3a51fdb1c52dc66a7c3c2936",
  "0x23773e65ed146a459791799d01336db287f25334",
  "0xd21be7248e0197ee08e0c20d4a96debdac3d20af",
  "0x610b717796ad172b316836ac95a2ffad065ceab4",
  "0x178169b423a011fff22b9e3f3abea13414ddd0f1",
  "0xbb93e510bbcd0b7beb5a853875f9ec60275cf498",
  "0x2717c5e28cf931547b621a5dddb772ab6a35b701",
  "0x03893a7c7463ae47d46bc7f091665f1893656003",
  "0xca0840578f57fe71599d29375e16783424023357",
  "0x58e8dcc13be9780fc42e8723d8ead4cf46943df2",
  "0x8589427373d6d84e98730d7795d8f6f8731fda16",
  "0x722122df12d4e14e13ac3b6895a86e84145b6967",
  "0xdd4c48c0b24039969fc16d1cdf626eab821d3384",
  "0xd90e2f925da726b50c4ed8d0fb90ad053324f31b",
  "0xd96f2b1c14db8458374d9aca76e26c3d18364307",
  "0x4736dcf1b7a3d580672cce6e7c65cd5cc9cfba9d"
]);
var isInSdn = (address) => {
  return sdnList.has(address.toLowerCase());
};
var validateIsInSdn = (address) => {
  if (isInSdn(address)) {
    throw new Error(
      `This address ${address} is in the U.S. SDN list. All transactions from this address will be rejected. Info: https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808`
    );
  }
};

// src/utils/address.ts
var NIL_ADDRESS = "0x0000000000000000000000000000000000000000";
function validateAddress(address) {
  if (Array.isArray(address)) {
    for (const addr of address) {
      validateAddress(addr);
    }
  } else {
    validateIsInSdn(address);
  }
}
var moduleResponseCache = void 0;
var lastModuleResponseCacheTime = 0;
async function getModules({
  type
} = {}) {
  const now = Date.now();
  const isMoreThanOneMinute = now - lastModuleResponseCacheTime > 60 * 1e3;
  let res = [];
  if (!moduleResponseCache || isMoreThanOneMinute) {
    res = await fetch(
      "https://raw.githubusercontent.com/Crossbell-Box/Crossbell-Contracts/main/deployments/modules.json"
    ).then((res2) => res2.json());
    moduleResponseCache = res;
    lastModuleResponseCacheTime = now;
  } else {
    res = moduleResponseCache;
  }
  if (type) {
    return res.filter((module) => module.type === type);
  }
  return res;
}
async function getModule(address) {
  const modules = await getModules();
  return modules.find((module) => isAddressEqual(module.address, address));
}
function getLinkModules() {
  return getModules({ type: "link" });
}
async function getLinkModule(address) {
  const modules = await getLinkModules();
  return modules.find(
    (module) => isAddressEqual(module.address, address) && module.type === "link"
  );
}
function getMintModules() {
  return getModules({ type: "mint" });
}
async function getMintModule(address) {
  const modules = await getMintModules();
  return modules.find(
    (module) => isAddressEqual(module.address, address) && module.type === "mint"
  );
}
async function getModuleConfig(m) {
  if (!m) {
    return {
      address: NIL_ADDRESS,
      initData: NIL_ADDRESS
    };
  }
  const module = await getModule(m.address);
  if (!module) {
    throw new Error(`Invalid module address ${m.address}`);
  }
  const initData = encodeAbiParameters(
    module.initDataStructure.map((item) => ({
      type: item.type
    })),
    m.data
  );
  return {
    address: m.address,
    initData
  };
}
async function encodeModuleInitData(moduleAddress, data) {
  const module = await getModule(moduleAddress);
  if (!module) {
    throw new Error(`Invalid module address ${moduleAddress}`);
  }
  const result = encodeAbiParameters(
    module.initDataStructure.map((item) => ({ type: item.type })),
    data
  );
  return result;
}
async function decodeModuleInitData(moduleAddress, initData) {
  const module = await getModule(moduleAddress);
  if (!module) {
    throw new Error(`Invalid module address ${moduleAddress}`);
  }
  const result = decodeAbiParameters(
    module.initDataStructure.map((item) => ({ type: item.type })),
    initData
  );
  return result;
}

// src/utils/validate-handle.ts
async function validateHandle(handle, indexer) {
  if (handle.length >= 32 || handle.length <= 2) {
    return "lengthInvalid";
  }
  if (!/^[\d_a-z-]+$/.test(handle)) {
    return "charsInvalid";
  }
  if (await checkIfExisted(handle, indexer)) {
    return "existed";
  }
  return null;
}
async function checkIfExisted(handle, indexer) {
  return !!await indexer.character.getByHandle(handle);
}
function validateHandleFormat(value, {
  disallowAddress = false
} = {}) {
  if (typeof value !== "string") {
    return {
      valid: false,
      code: "notAString",
      message: "Handle must be a string."
    };
  }
  if (value.length === 42 && value.startsWith("0x")) {
    if (disallowAddress) {
      return {
        valid: false,
        code: "shouldNotBeAddress",
        message: "Handle must not be an Ethereum address."
      };
    }
    return { valid: true, code: "valid", message: null };
  }
  if (value.length < 3 || value.length > 31) {
    return {
      valid: false,
      code: "invalidLength",
      message: "Handle must be between 3 and 31 characters."
    };
  }
  if (/^[\d_a-z-]+$/i.test(value)) {
    return { valid: true, code: "valid", message: null };
  }
  return {
    valid: false,
    code: "invalidChars",
    message: "Handle must only contain [a-z0-9-_]."
  };
}

export { NIL_ADDRESS, abi_exports, addressToAccount, cbt, createPublicClientFromChain, createTransport, createWalletClientFromPrivateKeyAccount, createWalletClientFromProvider, decodeModuleInitData, encodeModuleInitData, entry, getLinkModule, getLinkModules, getMintModule, getMintModules, getModule, getModuleConfig, getModules, getProviderAccount, linklist, mira, newbieVilla, parseLog, periphery, tips, tipsWithConfig, tipsWithFee, validateAddress, validateHandle, validateHandleFormat, validateIsInSdn, waitForTransactionReceiptWithRetry, warn };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-N4AJ44EV.mjs.map